 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML01_SERIES_PAGE from '@/components/xhtml/01_Series_Page'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML06_TRANSLATOR_S_NOTE from '@/components/xhtml/06_Translator_s_Note'
 import XHTML07_1__CAUSA_AND_CULPA from '@/components/xhtml/07_1__Causa_and_Culpa'
 import XHTML08_2__CRIMEN_AND_KARMAN from '@/components/xhtml/08_2__Crimen_and_Karman'
 import XHTML09_3__THE_APORIAS_OF_THE_WILL from '@/components/xhtml/09_3__The_Aporias_of_the_Will'
 import XHTML10_4__BEYOND_ACTION from '@/components/xhtml/10_4__Beyond_Action'
 import XHTML11_BIBLIOGRAPHY from '@/components/xhtml/11_Bibliography'
 import XHTML12_INDEX_OF_NAMES from '@/components/xhtml/12_Index_of_Names'
 import XHTML13_SERIES_LIST from '@/components/xhtml/13_Series_List'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/love_2",
 			"name" : "xhtml/love_2",
 			"component" : XHTMLLOVE_2
 		},
 		{
 			"path" : "/xhtml/06_Translator_s_Note",
 			"name" : "xhtml/06_Translator_s_Note",
 			"component" : XHTML06_TRANSLATOR_S_NOTE
 		},
 		{
 			"path" : "/xhtml/07_1__Causa_and_Culpa",
 			"name" : "xhtml/07_1__Causa_and_Culpa",
 			"component" : XHTML07_1__CAUSA_AND_CULPA
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js